import { Dialog } from "@mui/material";

import React, { useEffect, useState } from "react";

export default function KioskPreview({
    children,
}: {
    children: React.ReactNode;
}): JSX.Element {
    const [scale, setScale] = useState(1);

    useEffect(() => {
        const compute = () => {
            const s = Math.min(
                (window.innerWidth - 40) / 540,
                (window.innerHeight - 40) / 960,
                0.9
            );
            setScale(Math.max(s, 0.2));
        };
        compute();
        window.addEventListener("resize", compute);
        return () => window.removeEventListener("resize", compute);
    }, []);

    return (
        <>
            <style>{`
            .ReactModal__Overlay {
                z-index: 1301 !important;
            }
        `}</style>
            <Dialog
                open={true}
                fullScreen
                hideBackdrop={false}
                disableEscapeKeyDown
                PaperProps={{
                    style: {
                        background: "#0a0a0a",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "none",
                    },
                }}
            >
                <div
                    style={{
                        width: 540,
                        height: "100%",
                        transform: `scale(${scale})`,
                        transformOrigin: "center center",
                        position: "relative",
                        overflow: "hidden",
                        borderRadius: 8,
                        border: "2px solid #444",
                        flexShrink: 0,
                    }}
                >
                    {children}
                </div>
            </Dialog>
        </>
    );
}
